// extracted by mini-css-extract-plugin
export default {"project":"project_project__iqaAl","projectContent":"project_projectContent__SJsfo"};